<span
    class="px-1 text-xs/4 border rounded-sm"
    [ngClass]="color()"
    [innerHTML]="hotkey() | hotkeysShortcut">
</span>